const PING_LAT = -27.98678265830566;
const PING_LON = 24.729286273738964;

export type QueryRow = { key: string; value: string };

export function queryToRows(query?: Record<string, unknown> | null): QueryRow[] {
  const entries = Object.entries(query || {}).filter(([key]) => key.trim());
  if (!entries.length) {
    return [
      { key: 'latitude', value: '' },
      { key: 'longitude', value: '' },
    ];
  }
  return entries.map(([key, value]) => ({ key, value: value == null ? '' : String(value) }));
}

export function rowsToQuery(rows: QueryRow[]): Record<string, string> {
  const query: Record<string, string> = {};
  for (const row of rows) {
    const key = String(row.key || '').trim();
    const value = String(row.value ?? '').trim();
    if (!key || !value) continue;
    query[key] = value;
  }
  return query;
}

export function isHealthPingQuery(query?: Record<string, unknown> | null): boolean {
  const lat = Number((query as any)?.latitude ?? (query as any)?.lat);
  const lon = Number((query as any)?.longitude ?? (query as any)?.lon ?? (query as any)?.lng);
  return Number.isFinite(lat) && Number.isFinite(lon)
    && Math.abs(lat - PING_LAT) < 1e-9
    && Math.abs(lon - PING_LON) < 1e-9;
}

export function emptyInstanceQueryRows(): QueryRow[] {
  return [
    { key: 'latitude', value: '' },
    { key: 'longitude', value: '' },
  ];
}
